<template>
  <div>
    <div class="access">
      <div class="access__card">

        <div class="access-header">
          <img :src="logoUrl" alt="" width="150" class="access-header__logo">

          <h3 class="access-header__title">Claim Your Credit</h3>
          <div class="access-header__description">
            <h4>{{conference.name}}</h4>

            <div style="margin-bottom: 10px;">
              <span v-if="conference.date">{{conference.date}}</span>
              <span v-if="conference.time">({{conference.time}})</span>
            </div>
            <div v-if="conference.ce_hours" style="font-weight: 600;">EARN {{conference.ce_hours}} CE Credit Hours</div>
          </div>
        </div>

        <div v-show="!attendeeDashboardUrl">
          <validation-observer v-slot="{ invalid, valid, errors, ...rest }" ref="form">
            <form @submit.prevent="handleSubmit()" novalidate>
              <div class="name-fields">
                <div class="name-field">
                  <!-- first_name -->
                  <validation-provider vid="first_name" rules="required" v-slot="{errors}">
                    <div class="form-group">
                      <label for="first_name" class="control-label text-input">First Name <span class="asteric text-danger">*</span></label>
                      <input
                        id="first_name"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid': errors && errors[0]}"
                        name="first_name"
                        v-model="model.first_name"
                        maxlength="50"
                        required
                      />
                      <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                    </div>
                  </validation-provider>
                </div>

                <div class="name-field">
                  <!-- last_name -->
                  <validation-provider vid="last_name" rules="required" v-slot="{errors}">
                    <div class="form-group">
                      <label for="last_name" class="control-label text-input">Last Name <span class="asteric text-danger">*</span></label>
                      <input
                        id="last_name"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid': errors && errors[0]}"
                        name="last_name"
                        v-model="model.last_name"
                        maxlength="50"
                      />
                      <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <!-- full_name -->
              <validation-provider vid="full_name" v-slot="{errors}">
                <div class="form-group">
                  <label
                    for="full_name"
                    class="control-label text-input"
                  >
                    Full Name for CE Certificate (including any credentials - John Doe, MD)
                  </label>
                  <input
                    id="full_name"
                    type="text"
                    class="form-control"
                    :class="{'is-invalid': errors && errors[0]}"
                    name="full_name"
                    v-model="model.full_name"
                    maxlength="250"
                  />
                  <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                </div>
              </validation-provider>

              <!-- email -->
              <validation-provider vid="email" rules="required" v-slot="{errors}">
                <div class="form-group">
                  <label for="email" class="control-label text-input">Email <span class="asteric text-danger">*</span></label>
                  <input
                    id="email"
                    type="email"
                    class="form-control"
                    :class="{'is-invalid': errors && errors[0]}"
                    name="email"
                    v-model="model.email"
                    maxlength="250"
                  />
                  <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                </div>
              </validation-provider>

              <!-- additional_info -->
              <validation-provider vid="additional_info"  v-slot="{errors}">
                <div class="form-group">
                  <label
                    for="additional_info"
                    class="control-label text-input"
                  >
                    If you are a pharmacist please enter your date of birth and your NAPB
                    number (This is required to receive credit as a pharmacist)
                  </label>
                  <textarea
                    id="additional_info"
                    class="form-control"
                    :class="{'is-invalid': errors && errors[0]}"
                    name="additional_info"
                    v-model="model.additional_info"
                    rows="1"
                  />
                  <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                </div>
              </validation-provider>

              <div class="access__button">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="showIndicator"
                >
                  <span v-show="showIndicator"><i class="fa-regular fa-spinner fa-spin"></i></span> Proceed</button>
              </div>
            </form>
          </validation-observer>
        </div>

        <div v-if="attendeeDashboardUrl" style="text-align: center;">
          <a
            type="button"
            class="btn btn-primary"
            @click="goToDashboard()"
          >Attendee Dashboard</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import quickRegistrationAPI from "../../api/quickRegistrationAPI";

export default {
  props: {
    slug: {
      type: String,
      default: () => "",
    },
    conferenceId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.fetchConference();
  },
  data() {
    return {
      isFetching : false,
      showIndicator : false,
      model: {
        first_name: '',
        last_name: '',
        full_name: '',
        email: '',
        additional_info: '',
      },
      attendeeDashboardUrl: '',
      conference: {
        ce_hours: 0,
        date: '',
        description: '',
        event_logo_url: '',
        name: ''
      }
    }
  },
  computed: {
    logoUrl() {
      return this.conference.event_logo_url || '/logo-dark-transparent.png';
    }
  },
  methods: {
    fetchConference() {
      this.isFetching = true;

      quickRegistrationAPI
        .fetchQuickRegistration(this.slug)
        .then((res) => {
          this.conference = res.data?.data;

          console.log('=', res.data?.data);
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false;
        });
    },

    handleSubmit() {
      const data = this.model;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.showIndicator = true;

        quickRegistrationAPI
          .quickRegistration(this.slug, data)
          .then((res) => {
            this.attendeeDashboardUrl = res.data?.data?.attendee_dashboard_url;
            this.model = {
              first_name: '',
              last_name: '',
              full_name: '',
              email: '',
              additional_info: '',
            };

            this.goToDashboard();
          })
          .catch((err) => {
            if (err.errors) {
              this.$refs.form.setErrors(err.errors);
            }
          })
          .finally(() => {
            this.showIndicator = false;
          });
      });
    },

    goToDashboard() {
      if (this.attendeeDashboardUrl) {
        window.location.href = this.attendeeDashboardUrl;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 20px;
  font-weight: 600;
}

.name-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.name-field {
  flex: 1 1 100%;
}

@media (min-width: 768px) {
  .name-fields {
    gap: 15px;
  }

  .name-field {
    flex: 1 1 calc(50% - 7.5px);
  }
}

.access-header {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;

  &__logo {
    margin-bottom: 16px;

    @media (max-width: 900px) {
      margin-bottom: 60px;
    }
  }

  &__description {
    font-size: 16px;
    color: #001f5c;
    max-width: 500px;
    margin:  0 auto 16px;

    @media (max-width: 900px) {
      margin-bottom: 60px;
    }
  }

  &__title {
    font-size: 22px;
    color: #001f5c;
    margin-bottom: 16px;

  }
}


.access {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 16px;

  @media (min-width: 901px) {
    height: 100vh;
  }

  &__button {
    text-align: right;
    margin-top: 24px;
  }

  &__card {
    max-width: 800px;
    width: 100%;
    padding: 24px;
    border: 1px solid #ececec;
    border-radius: 12px;
    background-color: #ffffff;

    @media (max-width: 900px) {
      height: 100%;
    }
  }
}
</style>
